const FOCUS_STYLE_ID = 'rl-ocv-focus-visible-styles';

let activeDocument: Document | null = null;

/** Adds a visible keyboard-focus indicator to links rendered by the OCV portal. */
export const enforceFeedbackFocusVisible = (container: HTMLElement): void => {
  stopEnforcingFeedbackFocusVisible();

  const document = container.ownerDocument;
  const style = document.createElement('style');
  style.id = FOCUS_STYLE_ID;
  style.textContent = `
    [data-rl-feedback-dialog] a:focus-visible,
    [role="alertdialog"] a:focus-visible {
      outline: 2px solid #000000;
      outline-offset: 2px;
    }

    @media (forced-colors: active) {
      [data-rl-feedback-dialog] a:focus-visible,
      [role="alertdialog"] a:focus-visible {
        outline-color: CanvasText;
      }
    }
  `;
  document.head.appendChild(style);
  activeDocument = document;
};

/** Removes focus styles when the OCV dialog is dismissed. */
export const stopEnforcingFeedbackFocusVisible = (): void => {
  activeDocument?.getElementById(FOCUS_STYLE_ID)?.remove();
  activeDocument = null;
};
